var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ymap-marker',{attrs:{"marker-id":_vm.point,"coords":_vm.point?.split?.(';')?.[0]?.split(','),"icon":{
    layout: 'default#image',
    imageHref: `/img/marker.svg`,
    imageSize: [42, 42]
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }